import React, { FC, PropsWithChildren } from 'react'

import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { likePhotoActionWithHandlerError } from 'actions/photo/photoViewerLikePhotoAction'
import { Colors } from 'common-constants/colors'
import {
  PhotoButton,
  PhotoContainer,
} from 'components/page/PhotoViewer/Panel/PhotoButton'
import { HeartSvg } from 'components/presentational/svg/HeartSvg'
import { DarkLight } from 'components/presentational/theme/DarkLight'
import { push } from 'functions/router'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const PhotoCounterLike: FC<
  {
    photoId: number
    counterLike: number
    canVoting: boolean
    votable: boolean
    liked: boolean
    counterValueWrapper?: FC<PropsWithChildren>
  } & DarkLight &
    PropsWithChildren
> = ({
  photoId,
  counterLike,
  canVoting,
  votable,
  liked,
  dark = true,
  counterValueWrapper: ValueWrapper = ({ children }) => <>{children}</>,
}) => {
  const dispatch = useDispatch()
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  const authorizationPath = useAuthorizationPath()
  const openAuthorization = () => dispatch(push(authorizationPath))

  const handleClick = () => {
    if (authorized) {
      dispatch(likePhotoActionWithHandlerError(photoId))
    } else {
      openAuthorization()
    }
  }

  if (votable) {
    if (canVoting && !liked) {
      return (
        <PhotoButton
          onClick={handleClick}
          $dark={dark}
          data-name="photo-counter-like-action"
        >
          <HeartSvg fill={dark ? Colors.white : Colors.backgroundHoverLight} />
          <ValueWrapper>
            <Text data-name="photo-counter-text">{counterLike}</Text>
          </ValueWrapper>
        </PhotoButton>
      )
    }

    if (!canVoting && !liked) {
      return (
        <PhotoContainer $dark={dark} data-name="photo-counter-like">
          <HeartSvg fill={dark ? Colors.white : Colors.backgroundHoverLight} />

          <ValueWrapper>
            <Text data-name="photo-counter-text">{counterLike}</Text>
          </ValueWrapper>
        </PhotoContainer>
      )
    }

    return (
      <PhotoContainer $dark={dark} data-name="photo-counter-like">
        <HeartSvg fill={Colors.warning} />
        <ValueWrapper>
          <Text data-name="photo-counter-text">{counterLike}</Text>
        </ValueWrapper>
      </PhotoContainer>
    )
  }

  return null
}

const Text = styled.div`
  ${(props) => props.theme.marginLeft}: 5px;
`
